import axios from "axios";
const server = axios.create({
    // baseURL: process.env.VUE_APP_BASE_URL,
    baseURL: "http://hldapi.sctengsen.net/",
});

// 结果验证
const checkResults = msg => {
    let res = false;
    switch (msg) {
        case "ok":
            //结果正常，继续执行后续操作！
            res = true;
            break;
        case "token_expire":
            // 登录token失效
            // if (tokenExpire) {
            //     setTimeout(() => {
            //         tokenExpire = false;
            //     }, 2000);
            //     return false;
            // }
            window.localStorage.removeItem("token_expire");
            break;
        case "not_exist":
            // 请求内容不存在
            res = false;
            break;
    }
    return res;
};

// 请求拦截
server.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        Promise.reject(error);
    },
);

// 响应拦截
server.interceptors.response.use(
    response => {
        const {
            data: { data, msg },
        } = response;

        if (checkResults(msg)) {
            return response.data;
        }
        return Promise.reject(new Error(msg));
    },
    error => {
        Promise.reject(error);
    },
);

export default server;
